/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

// library imports
import { Component } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

// project imports
import { ForgotPassword, Signin, NotFound, SetPassword, VerifyEmail } from 'features/components';
import AppLayout from 'features/components/base/layouts/AppLayout';
import { isAuthenticated, isAuthorized } from 'shared/settings/auth';

// style imports
import 'react-toastify/dist/ReactToastify.css';

/**
 * routing for all features components
 * 
 * @param props
 * 
 * @return routing for all features components
 * 
**/

export class FeaturesRouter extends Component {

    constructor(props) {
        super(props);

        this.state = {
            page: false
        };
    }

    componentDidMount() {
        isAuthenticated(this.props.history)
            .then(res => {
                this.setState({ page: true });
            });
    }

    render () {
        return (this.state.page ?
            <>
                <ToastContainer />
                <Switch>
                    <Route exact path="/">
                        {
                            isAuthorized() ? <Redirect to="/home" /> : <Signin {...this.props} />
                        }
                    </Route>
                    <Route exact path="/forgot-password">
                        {
                            isAuthorized() ? <Redirect to="/home" /> : <ForgotPassword {...this.props} />
                        }
                    </Route>
                    <Route exact path="/set-password">
                        {
                            isAuthorized() ? <Redirect to="/home" /> : <SetPassword {...this.props} />
                        }
                    </Route>
                    <Route exact path="/verify-email">
                        {
                            () => {
                                return isAuthorized(true) ? <Redirect to="/home" /> : <VerifyEmail {...this.props} />
                            }
                        }
                    </Route>
                    <Route exact path="/not-found" component={NotFound} />
                    <Route>
                        {
                            isAuthorized() ? <AppLayout {...this.props} /> : <Redirect to="/" />
                        }
                    </Route>
                    <Redirect to="/home" />
                </Switch>
            </> :
            <div className="d-flex flex-row justify-content-center align-items-center w-100 h-100">
                <img src={`${process.env.PUBLIC_URL}/static/icons/table/option_1.gif`} alt="Please wait ....." height="100px" width="100px" />
            </div>
        );
    }
}
